import React from 'react';
import { executiveSummary, heroData } from '../data/mock';
import { Quote } from 'lucide-react';

const ExecutiveSummary = () => {
  return (
    <section className="executive-summary-section">
      <div className="container">
        <div className="executive-content">
          <div className="executive-intro">
            <span className="section-label">Executive Profile</span>
            <h2 className="heading-2">A Visionary Leader in Civil Engineering</h2>
          </div>
          
          <div className="executive-body">
            <div className="summary-card">
              <div className="quote-icon">
                <Quote size={48} />
              </div>
              <p className="body-large intro-text">{executiveSummary.intro}</p>
              <p className="body-medium body-text">{executiveSummary.body}</p>
              
              <div className="executive-signature">
                <div className="signature-line"></div>
                <div className="signature-info">
                  <span className="signature-name">{heroData.name}</span>
                  <span className="signature-title">{heroData.title}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExecutiveSummary;
